import Vue from 'vue'
import Vuex from 'vuex'
import { namespace } from 'vuex-class'

import app from './modules/app'
import dictionary from './modules/dictionary'
import contract from './modules/contract'

Vue.use(Vuex)

export const AppModule = namespace('app')
export const DictionaryModule = namespace('dictionary')
export const ContractModule = namespace('contract')

export default new Vuex.Store<any>({
  state: {
  },
  mutations: {
  },
  actions: {

  },
  modules: {
    app,
    dictionary,
    contract
  },
  getters: {
  }
})
